"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toIconTitleId = exports.toIconDescriptionId = exports.getAriaLabel = exports.defaultFill = void 0;
var defaultFill = 'var(--color-icon-fill)';
exports.defaultFill = defaultFill;
var kebabRegex = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g;

var toKebabCase = function toKebabCase(string) {
  return (string.match(kebabRegex) || []).map(function (x) {
    return x.toLowerCase();
  }).join('-');
};

var toIconTitleId = function toIconTitleId(title) {
  return "svg-icon-id-title-".concat(toKebabCase(title));
};

exports.toIconTitleId = toIconTitleId;

var toIconDescriptionId = function toIconDescriptionId(description) {
  return "svg-icon-id-description-".concat(toKebabCase(description));
};

exports.toIconDescriptionId = toIconDescriptionId;

var getAriaLabel = function getAriaLabel(_a) {
  var title = _a.title,
      description = _a.description;
  return "".concat(toIconTitleId(title), " ").concat(description ? toIconDescriptionId(description) : '');
};

exports.getAriaLabel = getAriaLabel;